
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 10.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8.128 12.882h-.25L5.875 14a6.538 6.538 0 01-2.132-1.2l-.007-2.25a3.33 3.33 0 01-.125-.213L1.619 9.203a6.197 6.197 0 010-2.404l1.99-1.131c.04-.072.082-.144.125-.214l.01-2.25A6.536 6.536 0 015.875 2l2 1.118h.25l2-1.118c.78.262 1.503.67 2.132 1.2l.007 2.25c.045.07.087.14.125.213l1.991 1.134c.157.793.157 1.61 0 2.404l-1.99 1.13a7.98 7.98 0 01-.125.214l-.01 2.25A6.537 6.537 0 0110.125 14l-1.997-1.118z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    